module.exports = ""


//////////////////
// WEBPACK FOOTER
// /var/www/html/foodbot_stage/web/src/app/reservation/reservation.component.html
// module id = ../../../../../src/app/reservation/reservation.component.html
// module chunks = main